import React from 'react'
import "./SmallLoader.scss";

const SmallLoader = () => {
    return (
        <div className='SmallLoader'>
            <div class="loader"></div>
        </div>
    )
}

export default SmallLoader